import _ from 'lodash';
import visionService from '@/services/visionService';
import Vision from '../../model/vision';

const state = {
  baseUrl: '/vision',
  visions: [],
  pagination: {},
  vision: null,
  loading: false
};

const actions = {
  list({ dispatch, commit }, { type = 'vision', query = {}, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setVisions', { visions: [], pagination: {} });

    visionService
      .list({ type, query })
      .then(response => {
        commit('setVisions', { visions: response.data.rows, pagination: response.data.pagination });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  getOne({ dispatch, commit }, { type = 'vision', visionId, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    commit('setVision', { vision: {} });

    visionService
      .getOne({ type, visionId })
      .then(response => {
        commit('setVision', { vision: response.data });
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  postOne({ dispatch, commit }, { type = 'vision', vision, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    visionService
      .postOne({ type, vision })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'bottom-end',
            title: '',
            text: type === 'vision' ? 'New vision has been added.' : 'New vision has been added.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  patchOne({ dispatch, commit }, { type = 'vision', visionId, vision, router, redirectUrl = '' }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    visionService
      .patchOne({ type, visionId, newVision: vision })
      .then(_response => {
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'bottom-end',
            title: '',
            text: type === 'vision' ? 'Vision has been updated.' : 'Vision has been updated.'
          },
          { root: true }
        );

        if (redirectUrl !== '') {
          router.push(redirectUrl);
        }
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  },
  deleteOne({ dispatch, commit }, { type = 'vision', visionId, router }) {
    dispatch('alert/clear', {}, { root: true });
    commit('startRequest');

    visionService
      .deleteOne({ type, visionId })
      .then(_response => {
        dispatch('list', { type });
        dispatch(
          'alert/success',
          {
            showType: 'toast',
            position: 'bottom-end',
            title: '',
            text: type === 'vision' ? 'Vision has been deleted.' : 'Vision has been deleted.'
          },
          { root: true }
        );
      })
      .catch(e => {
        commit('requestFailed');
        dispatch('common/handleServiceException', { e, router }, { root: true });
      });
  }
};

const getters = {};

const mutations = {
  startRequest(state) {
    state.loading = true;
  },
  requestFailed(state) {
    state.loading = false;
  },
  setVisions(state, { visions, pagination }) {
    let rowNum = pagination.first_row_no;
    state.visions = _.map(visions, vision => {
      const newVision = new Vision({
        rowNum,
        id: vision.id,
        userId: vision.user_id,
        modulId: vision.modul_id,
        name: vision.name,
        note: vision.note,
        position: vision.position,
        score: vision.score,
        thresholdNegative: vision.threshold_negative,
        thresholdNeutral: vision.threshold_neutral,
        thresholdPositive: vision.threshold_positive,
        state: vision.state,
        status: vision.status,
        statusName: vision.statusName,
        createdAt: vision.created_at,
        updatedAt: vision.updated_at
      });

      rowNum -= 1;
      return newVision;
    });
    state.pagination = pagination;

    state.loading = false;
  },
  setVision(state, { vision }) {
    state.vision = new Vision({
      id: vision.id,
      userId: vision.user_id,
      modulId: vision.modul_id,
      name: vision.name,
      note: vision.note,
      position: vision.position,
      score: vision.score,
      thresholdNegative: vision.threshold_negative,
      thresholdNeutral: vision.threshold_neutral,
      thresholdPositive: vision.threshold_positive,
      state: vision.state,
      status: vision.status,
      statusName: vision.statusName,
      createdAt: vision.created_at,
      updatedAt: vision.updated_at
    });

    state.loading = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
